import Menus from "../Menus";

const HelpTopicJuridiques = () => {
  const goBackLinks = [
    { label: 'Accueil', link: '/'},
    { label: 'Tous les sujets', link: '/topics'},
    { label: 'À propos de Wodzone', link: '/topics/about'},
    { label: 'Conditions juridiques', link: '/topics/about/juridiques'},
  ]
    
  const multiMenus = [
    {title: 'Conditions générales', filter: 'HelpTopicJuridiques_1'},
    {title: 'Politique de confidentialité', filter: 'HelpTopicPolitiqueConfidentialite'},
  ]

  return <Menus goBackLinks={goBackLinks} multiMenus={multiMenus}/>
}

export default HelpTopicJuridiques